import _permissao from "@universidade-franciscana/componente-front/src/enums/permissao"

export default [
  {
    path: "/conjunto",
    name: "Conjunto",
    component: () => import("@/view/Estrutura/Conjunto.vue"),
    meta: {
      titulo: "Conjunto",
      caminho: "espacofisico",
      tipoPermissao: _permissao.LISTAR,
      requerAutenticacao: false,
      breadcrumb: [
        { text: "Conjunto", disabled: true, to: "/" },
      ],
    },
  },
  {
    path: "/predio",
    name: "Predio",
    component: () => import("@/view/Estrutura/Predio.vue"),
    meta: {
      titulo: "Predio",
      tipoPermissao: _permissao.LISTAR,
      caminho: "espacofisico",
      requerAutenticacao: false,
      breadcrumb: [
        { text: "Conjunto", disabled: false, to: "/conjunto" },
        { text: "Predio", disabled: true, to: "/" },

      ],
    },
  },
  {
    path: "/predio/:id",
    name: "Predio",
    component: () => import("@/view/Estrutura/Predio.vue"),
    meta: {
      titulo: "Predio",
      tipoPermissao: _permissao.LISTAR,
      caminho: "espacofisico",
      requerAutenticacao: false,
      breadcrumb: [
        { text: "Conjunto", disabled: false, to: "/conjunto" },
        { text: "Predio", disabled: true, to: "/" },

      ],
    },
  },
  {
    path: "/espacoFisico",
    name: "EspacoFisico",
    component: () => import("../../view/Estrutura/EspacoFisico.vue"),
    meta: {
      titulo: "Espaco Fisico",
      tipoPermissao: _permissao.LISTAR,
      caminho: "espacofisico",
      requerAutenticacao: false,
      breadcrumb: [
        { text: "Conjunto", disabled: false, to: "/conjunto" },
        { text: "Predio", disabled: false, to: "/predio" },
        { text: "Espaco Fisico", disabled: true, to: "/" },
      ],
    },
  },
  {
    path: "/espacoFisico/:id",
    name: "EspacoFisico",
    component: () => import("@/view/Estrutura/EspacoFisico.vue"),
    meta: {
      titulo: "Espaco Fisico",
      caminho: "espacofisico",
      tipoPermissao: _permissao.LISTAR,
      breadcrumb: [
        { text: "Conjunto", disabled: false, to: "/conjunto" },
        { text: "Predio", disabled: false, to: "/predio" },
        { text: "Espaco Fisico", disabled: true, to: "/" },
      ],
    },
  },
]